import {css} from 'lit';
import {tablet} from '../../js/services/const';

export default css`
  :host {
    --facebook: #316FF6;
    --twitter: #000000;
    --whatsapp: #25d366;
    border-radius: 4px;
  }

  :host(.hidden) {
    display: none;
  }

  .wrapper {
    border-radius: 4px;
    display: inline-block;
    overflow: hidden;
    direction: ltr;
    text-indent: -999rem;
    font-size: 1.4rem;
    line-height: 4rem;
    position: relative;
    box-sizing: border-box;
    height: 3.2rem;
    width: 3.2rem;
  }

  .sb {
    border: 0;
    cursor: pointer;
    background: transparent;
    display: block;
    overflow: hidden;
    direction: ltr;
    text-indent: -999rem;
    font-size: 1.4rem;
    line-height: 4rem;
    position: relative;
    box-sizing: border-box;
    height: 100%;
    width: 100%;
  }

  :host:focus,
  :host:focus-within,
  .sb:focus,
  .sb:focus-within {
    outline: none;
  }

  .sb .icon-svg-facebook,
  .sb .icon-svg-twitter,
  .sb .icon-svg-mail,
  .sb .icon-svg-whatsapp,
  .sb .icon-svg-share {
    color: var(--white, #fff);
    width: 100%;
    font-size: 2rem;
    line-height: 4rem;
    text-align: center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
  }

  .sb .icon-svg-facebook:before,
  .sb .icon-svg-twitter:before,
  .sb .icon-svg-mail:before,
  .sb .icon-svg-whatsapp:before
  .sb .icon-svg-share:before {
    position: absolute;
    top: 0;
    left: 0;
    text-indent: 0;
    width: 100%;
    text-align: center;
  }

  :host([type='mail']) {
    background-color: var(--social-background-color);
  }
  :host([type='whatsapp']) {
    background-color: var(--whatsapp);
  }
  :host([type='twitter']) {
    background-color: var(--twitter);
  }
  :host([type='facebook']) {
    background-color: var(--facebook);
  }
  :host([type='share']) {
    background-color: var(--cp-grey-light-2);
  }

  @media (min-width: ${tablet}px) {
    :host(:hover) .sb-twitter:hover {
      background-color: var(--twitter);
    }
    :host(:hover) .sb-facebook:hover {
      background-color: var(--facebook);
    }
    :host(:hover) .sb-mail:hover {
      background-color: var(--social-background-color);
    }
    :host(:hover) .sb-whatsapp:hover {
      background-color: var(--whatsapp);
    }
    :host(:hover) .sb-share:hover {
      background-color: var(--cp-grey-light-2);
    }
  }
`;
